define('tavanoteam_product_views_price.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('tavanoteam_product_views_price', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/TavanoTeamStaging/PDP_Extension/1.0.4/', 'extensions/TavanoTeamStaging/PDP_Extension/1.0.4/', Handlebars);
});